<template>
	<div class="wrapper">
		<b-row>
			<b-col cols="12">
				<b-card header-tag="header">
					<template v-slot:header>
						<i class="fa fa-list"></i> Subscription Requests
					</template>

					<b-card-body>
						<!-- Office Filter -->
						<b-form-group label="Filter by Office" label-for="office-filter" :label-cols="2" :horizontal="true" class="mb-4">
							<multiselect
								id="office-filter"
								v-model="selectedOffice"
								:options="officeList"
								:searchable="true"
								:allow-empty="true"
								label="name"
								track-by="id"
								placeholder="All Offices"
								@input="onOfficeChange()"
							/>
						</b-form-group>

						<!-- Loading Spinner -->
						<div v-if="loading" class="text-center my-4">
							<b-spinner label="Loading..." style="width: 3rem; height: 3rem;" variant="info"></b-spinner>
						</div>

						<!-- Table -->
						<div v-else>
							<b-table
								:items="requestList"
								:fields="fields"
								:per-page="perPage"
								:current-page="currentPage"
								hover
								striped
								bordered
								small
								responsive
								show-empty
								empty-text="No subscription requests found."
							>
								<!-- Office Name -->
								<template v-slot:cell(office)="row">
									{{ row.item.office ? row.item.office.name : '—' }}
								</template>

								<!-- Current Version -->
								<template v-slot:cell(current)="row">
									<b-badge :variant="badgeColor(row.item.currentVersion ? row.item.currentVersion.name : null)">{{ row.item.currentVersion ? row.item.currentVersion.name : '—' }}</b-badge>
								</template>

								<!-- Upgrade Version -->
								<template v-slot:cell(plan)="row">
									<b-badge :variant="badgeColor(row.item.upgradeVersion ? row.item.upgradeVersion.name : null)">{{ row.item.upgradeVersion ? row.item.upgradeVersion.name : '—' }}</b-badge>
								</template>


								<!-- Number of Employees -->
								<template v-slot:cell(numberOfEmployees)="row">
									{{ row.item.numberOfEmployees || '—' }}
								</template>

								<!-- Phone Number -->
								<template v-slot:cell(phoneNumber)="row">
									{{ row.item.phoneNumber || '—' }}
								</template>

							</b-table>

							<!-- Pagination -->
							<b-row class="mt-3">
								<b-col cols="6" class="d-flex align-items-center">
									<span class="text-muted small">Showing {{ paginationInfo }}</span>
								</b-col>
								<b-col cols="6">
									<b-pagination
										v-model="currentPage"
										:total-rows="requestList.length"
										:per-page="perPage"
										align="right"
										size="sm"
										class="my-0"
									/>
								</b-col>
							</b-row>
						</div>
					</b-card-body>
				</b-card>
			</b-col>
		</b-row>
	</div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import toastService from '@/services/toastService';
import officeService from '@/services/officeService';
import subscriptionService from '@/services/subscriptionService';

export default {
	name: 'SubscriptionRequestList',
	components: { Multiselect },
	data() {
		return {
			officeList: [],
			selectedOffice: null,
			requestList: [],
			loading: false,
			currentPage: 1,
			perPage: 20,
			fields: [
				{ key: 'id',                label: 'ID',                     sortable: true  },
				{ key: 'office',            label: 'Office',                 sortable: false },
				{ key: 'current',    				label: 'Current Package',        sortable: false },
				{ key: 'plan',    					label: 'Package Update Request', sortable: false },
				{ key: 'numberOfEmployees', label: 'No. of Employees',       sortable: false },
				{ key: 'phoneNumber',       label: 'Phone Number',           sortable: false }
			],
		};
	},
	computed: {
		paginationInfo() {
			const total = this.requestList.length;
			if (total === 0) return '0 records';
			const start = (this.currentPage - 1) * this.perPage + 1;
			const end   = Math.min(this.currentPage * this.perPage, total);
			return `${start}–${end} of ${total}`;
		},
	},
	methods: {
		loadRequests() {
			this.loading = true;
			const params = {};
			if (this.selectedOffice) {
				params.officeId = this.selectedOffice.id;
			}
			subscriptionService.getSubscriptionRequests(
				params,
				(data) => {
					this.requestList = data.content || [];
					this.currentPage = 1;
					this.loading = false;
				},
				(msg) => {
					toastService.showErrorToast(msg || 'Failed to load subscription requests');
					this.loading = false;
				}
			);
		},
		badgeColor(status) {
			if(status === 'Essential') return 'success';
			if(status === 'Standard') return 'info';
			if(status === 'Premium') return 'secondary';
			return 'warning';
		},
		onOfficeChange() {
			this.loadRequests();
		},
		statusLabel(status) {
			const map = { 0: 'Pending', 1: 'Active', 2: 'Expired', 3: 'Cancelled' };
			return map[status] !== undefined ? map[status] : String(status);
		},
		statusVariant(status) {
			const map = { 0: 'warning', 1: 'success', 2: 'danger', 3: 'secondary' };
			return map[status] !== undefined ? map[status] : 'light';
		},
	},
	mounted() {
		officeService.getOfficeList(
			(list) => { this.officeList = list; },
			() => { toastService.showErrorToast('Failed to load office list'); }
		);
		this.loadRequests();
	},
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
